import { createAction } from '@reduxjs/toolkit';

// Owned topics use Published in the API. Shared learner progress is a separate model.
export const topicCompletionUpdated = createAction<{
  guid: string;
  published: boolean;
  updatedAt?: string;
}>('topicCompletion/updated');
